<template>
  <div class="nearby-shop">
    <div class="nearby-mark"></div>
    <div class="nearby-body" @click="shopDetails(item)">
      <div class="nearby-logo" :style="item.shopBanner ? `background-image:url(${item.shopBanner});` : ''">
        <div :class="[item.infoStatus === '在线' ? 'shop-tag-active' : '', 'shop-tag']">{{ i18n[item.infoStatus] }}</div>
      </div>
      <div class="nearby-body-content">
        <div class="nearby-title">{{ item.shopName }}</div>
        <div class="nearby-body-row">
          <img src="@/assets/imgs/shop/icon_shop_address.png" alt="">
          <div class="nearby-body-row-text">{{ item.shopAddress1 }}</div>
        </div>
        <div class="nearby-body-row">
          <img src="@/assets/imgs/shop/icon_shop_time.png" alt="">
          <div class="nearby-body-row-text">{{ item.shopTime }}</div>
        </div>
      </div>
    </div>
    <div class="nearby-device" @click="shopDetails(item)">
      <div class="nearby-device-item">
        <img src="@/assets/imgs/shop/icon_shop_cabinet.png" alt="">
        <div class="nearby-device-info">
          <div class="nearby-device-title">{{ item.freeNum }}</div>
          <div>{{ $t("shop.shop_power_banks") }}</div>
        </div>
      </div>
      <div class="nearby-device-line"></div>
      <div class="nearby-device-item">
        <img src="@/assets/imgs/shop/icon_charge_available.png" alt="">
        <div class="nearby-device-info">
          <div class="nearby-device-title">{{ parseInt(item.batteryNum - item.freeNum) }}</div>
          <div>{{ $t("shop.shop_empty_slots") }}</div>
        </div>
      </div>
    </div>
    <div class="nearby-btn" @click="onClick('shop_scan')">
      <img src="@/assets/imgs/icon_scan.png" alt="">
      <span>{{ i18n.scan }}</span>
    </div>
    <img @click="goNearbyShop(item)" class="nearby-nav" src="@/assets/imgs/shop/icon_shop_nav2.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    i18n() {
      return this.$t("map")
    }
  },
  methods: {
    onClick(type) {
      this.$emit("click", type)
    },
    // 站点详情
    shopDetails(item) {
      this.$store.commit("shopInfo", item)
      this.$router.push(`/shop/details/${item.id}`)
    },
    // 附近站点
    goNearbyShop() {
      const jumpPath = `https://www.google.com/maps/dir/`
      window.open(
        `${jumpPath}?api=1&destination=${this.shopDetails.latitude},${this.shopDetails.longitude}&travelmode=bicycling`
      )
    }
  },
  created() {}
}
</script>

<style lang="less" scoped>
.nearby-shop {
  position: fixed;
  left: 35px;
  right: 35px;
  bottom: 35px;
  z-index: 100;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 28px;
  color: #000;
  .nearby-mark {
    width: 150px;
    height: 8px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.1);
    margin: 0 auto;
  }
  .nearby-body {
    padding: 46px 0 30px;
    border-bottom: 1px solid rgba(224, 224, 224, 0.5);
    display: flex;
    align-items: center;
    .nearby-logo {
      width: 151px;
      height: 151px;
      background-image: url('../../assets/imgs/banner-home.jpg');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 10px;
      position: relative;
      .shop-tag {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 22px;
        text-align: center;
        padding: 6px 0;
        background: #C2C2C2;
        color: #fff;
        border-radius: 0 0 10px 10px;
      }
      .shop-tag-active {
        background: #FFCA0E;
      }
    }
    .nearby-body-content {
      flex: 1;
      padding-left: 28px;
      .nearby-title {
        color: #231F20;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .nearby-body-row {
        display: flex;
        align-items: center;
        padding-top: 5px;
        .nearby-body-row-text {
          padding-left: 9px;
          font-size: 22px;
          color: #A9ABAD;
        }
        img {
          width: 35px;
          height: 35px;
        }
      }
    }
  }
  .nearby-device {
    display: flex;
    padding: 30px 0 24px;
    align-items: center;
    .nearby-device-item {
      flex: 1;
      height: 77px;
      padding: 0 18px;
      display: flex;
      align-items: center;
      background: rgba(255, 202, 14, 0.1);
      border-radius: 16px;
      .nearby-device-info {
        padding-left: 18px;
        font-size: 20px;
        color: rgba(64, 64, 65, 0.4);
        .nearby-device-title {
          color: #404041;
          font-size: 26px;
          font-weight: 600;
        }
      }
      img {
        width: 49px;
        height: 49px;
      }
    }
    .nearby-device-line {
      height: 64px;
      width: 1px;
      margin: 0 26px;
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .nearby-btn {
    height: 123px;
    border-radius: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    background: #FFCA0E;
    border-radius: 28px;
    img {
      width: 95px;
      height: 95px;
      display: block;
      margin-right: 30px;
    }
  }
  .nearby-nav {
    position: absolute;
    top: 30px;
    right: 49px;
    width: 47px;
    height: 47px;
  }
}
</style>
